
import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SectionLayout from '@/components/SectionLayout';

// Add type declaration for the NDRSL property on the Window interface
declare global {
  interface Window {
    NDRSL: {
      init: () => void;
    };
  }
}

const WallOfLove = () => {
  useEffect(() => {
    // Create and load the Endorsal script
    const script = document.createElement('script');
    script.src = 'https://cdn.endorsal.io/widgets/widget.min.js';
    script.async = true;
    
    // Initialize the widget once the script loads
    script.onload = () => {
      if (window.NDRSL) {
        window.NDRSL.init();
      }
    };
    
    document.body.appendChild(script);
    
    // Clean up on unmount
    return () => {
      document.body.removeChild(script);
      
      // Remove any existing widgets from previous renders
      const existingWidgets = document.querySelectorAll('.ndrsl-widget-loaded');
      existingWidgets.forEach(widget => {
        if (widget.parentNode) {
          widget.parentNode.removeChild(widget);
        }
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      <SectionLayout paddingY="py-16" mobilePaddingY="py-12" backgroundColor="bg-white">
        <div className="pt-16 md:pt-20">
          <h1 className="text-3xl md:text-4xl font-bold text-[#003a70] mb-8 text-center">✨ Wall of Love ❤️</h1>
          
          <div className="max-w-3xl mx-auto mb-12 bg-[#FEE6D8]/30 rounded-lg p-6 border border-[#FEE6D8] shadow-md">
            <p className="text-gray-700 text-center leading-relaxed text-xl">
              See what our customers are saying about AskSpot. Real testimonials from real users who are building incredible Ai powered tools with AskSpot
            </p>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 md:p-8">
            <div id='ndrsl-wol-65fb2b1f2861c0430c92b45a' className='ndrsl-widget'></div>
          </div>
        </div>
      </SectionLayout>
      <Footer />
    </>
  );
};

export default WallOfLove;
